import React from 'react';
import { Tabs, Tab, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Page, Header, Content, HeaderLabel } from '@backstage/core-components';
import { DashboardView } from '../DashboardView/DashboardView';
import { AssetListView } from '../AssetListView/AssetListView';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
  },
  tabs: {
    backgroundColor: theme.palette.background.paper,
  },
}));

export const AssetRegisterPage = (): JSX.Element => {
  const classes = useStyles();
  const [selectedTab, setSelectedTab] = React.useState(0);

  const handleTabChange = (_event: React.ChangeEvent<{}>, newValue: number) => {
    setSelectedTab(newValue);
  };

  return (
    <Page themeId="tool">
      <Header
        title="IT Asset Register"
        subtitle="Track and manage IT assets, licenses, and infrastructure"
      >
        <HeaderLabel label="Owner" value="MOH ICT" />
      </Header>
      <Content className={classes.root}>
        <Box className={classes.tabs}>
          <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
          >
            <Tab label="Dashboard" />
            <Tab label="Assets" />
          </Tabs>
        </Box>
        <Box mt={2}>
          {selectedTab === 0 && <DashboardView />}
          {selectedTab === 1 && <AssetListView />}
        </Box>
      </Content>
    </Page>
  );
};
